import MainLayout from "components/layouts/main/Main.layout";
import Principal from "components/pages/home/principal/Principal.component";

export default function HomePage() {
  return(
     <MainLayout>
       <Principal />
     </MainLayout>
  );
};